import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { useDispatch, useSelector } from "react-redux";

import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import Loader from "../../../components/shared/Loader";
import { updateMeta } from "../../../store/actions/metaAction";
import { v4 } from "uuid";

const LinksIndex = () => {
	const auth = useSelector(state => state.auth.user);
	const [socials, setSocials] = useState([]);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();
	console.log(socials);
	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع روابط التواصل",
				breadcrumb: "روابط التواصل",
				button: {
					show: true,
					text: "اضافة رابط جديد",
					link: "/social/links/create",
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/settings/socials`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				// setSocials([...response.data.data.socials.filter()]);
				setSocials(response.data.data.socials);
				setLoading(false);
			})
			.catch(function (error) {
				console.log(error);
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const columns = [
		// {
		// 	name: "id",
		// 	selector: "id",
		// 	sortable: true,
		// },
		{
			name: "النوع",
			selector: row => row.socialType?.name.ar ?? null,
			sortable: true,
		},
		{
			name: "الاسم",
			selector: "name.ar",
			sortable: true,
		},
		{
			name: "الرابط",
			selector: row => row?.link ?? null,
			sortable: true,
		},
		{
			name: "",
			selector: "settings",
			cell: row => (
				<ul className="list-inline settingsList">
					<li className="list-inline-item">
						{/* {!["phone", "email", "location address"].includes(
							row?.socialType?.name?.en
						) ? ( */}
						<button
							className="bt bt-sm bt-danger"
							onClick={() => handleConfrimDelete(row.id)}
						>
							<i className="fas fa-trash"></i>
						</button>
						{/* ) : null} */}
					</li>
					<li className="list-inline-item">
						<Link
							className="bt bt-sm bt-success"
							to={`/social/links/show/${row.id}`}
						>
							<i className="fas fa-edit"></i>
						</Link>
					</li>
				</ul>
			),
		},
	];

	const handleConfrimDelete = articleID => {
		confirmAlert({
			title: "تأكيد الحذف",
			message: "هل أنت متأكد من رغبتك في الحذف؟",
			buttons: [
				{
					label: "نعم",
					onClick: () => deleteArticle(articleID),
				},
				{
					label: "لا",
					onClick: () => console.log("No"),
				},
			],
		});
	};

	const deleteArticle = CommentID => {
		axios
			.delete(
				`${process.env.REACT_APP_API_URL}/settings/socials//${CommentID}`,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(_ => onStart() && toast.success("تم الحذف بنجاح"))
			.catch(_ => toast.error("حدث خطا!"));
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="datatable">
				<DataTableExtensions columns={columns} data={socials}>
					<DataTable
						noHeader
						defaultSortField="id"
						defaultSortAsc={false}
						pagination
						highlightOnHover
						direction="rtl"
						striped
					/>
				</DataTableExtensions>
			</div>
		</section>
	);
};

export default LinksIndex;
